import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") return toast.error("Acesso restrito a administradores");
      nav("/admin");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#181818] flex items-center justify-center p-4">
      <form onSubmit={submit} className="bg-white rounded-2xl p-8 w-full max-w-md space-y-4">
        <div className="text-center mb-4">
          <span className="font-extrabold text-2xl text-[#C91F1F]" style={{ fontFamily: "Outfit" }}>NALIN</span>
          <p className="text-sm text-neutral-500 mt-1">Painel administrativo</p>
        </div>
        <div><Label>E-mail</Label><Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
        <div><Label>Senha</Label><Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
        <Button data-testid="admin-login-submit" disabled={loading} className="w-full bg-[#C91F1F] hover:bg-[#9F1515] h-11">
          {loading ? "Entrando..." : "Acessar painel"}
        </Button>
      </form>
    </div>
  );
}
